import React from 'react';

import { Analytics } from '@cowbell/data/analytics';

export const analytics = new Analytics({ enabled: true });

export interface ProviderProps {
  instance?: Analytics;
  children: React.ReactNode;
}

export const AnalyticsContext = React.createContext<
  ProviderProps['instance'] | null
>(analytics);
